import styles from "./FilterCard.module.css"
import { LucideIcon } from 'lucide-react';
import { FilterTypes } from "../../../types/product.types";
import { svgList } from "../../../constants/filters";
/**
* Props for FilterCard
*/
interface FilterCardProps{
    text?: string, // Card label
    customIcon?: LucideIcon, // Optional custom icon
    filterKey: FilterTypes, // Filter key
    onClick: (key:FilterTypes)=>void, // Click event handler
    selected?: boolean, // Whether filter is selected
    filled?: boolean, // Whether the icon should be filled
    className?:string // Optional additional classname
}
/**
* A filter card component with an icon and label.
*
* @param props FilterCard props
* @param {string} props.text - Optional label text for the card
* @param {LucideIcon} props.customIcon - Optional custom icon (Lucide)
* @param {FilterTypes} props.filterKey - Filter key used to identify the filter
* @param {(key: FilterTypes) => void} props.onClick - Callback fired when card is clicked
* @param {boolean} props.selected - Whether the filter is currently selected
* @param {boolean} props.filled - Whether the icon should be filled
* @param {string} props.className - Optional additional CSS class
* @returns TSX.Element
*/
const FilterCard = ({text, filterKey, customIcon: CustomIcon, onClick, selected = false, filled = false, className}:FilterCardProps) => {
    const Icon = svgList[filterKey]; // Current icon

    return(
        <>
            <button className={`${styles.FilterCard} ${selected ? styles.Selected : ''} ${className ?? ''}`.trim()} onClick={()=>onClick(filterKey)} >
                <div className={styles.FilterIcon}>
                    {CustomIcon ? <CustomIcon style={filled? {fill:"#333333"} : {}}/> : <Icon/>}
                </div>
                    {text && <div className={styles.FilterText}><p>{text}</p></div>}
            </button>
        </>
    )
};

export default FilterCard;